import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

// image imports
import physical_therapy from '../../../assets/images/home_screen/slider/physical_therapy.jpg';
import occupational_therapy from '../../../assets/images/home_screen/slider/occupational_therapy.jpg';
import speech_therapy from '../../../assets/images/home_screen/slider/speech_therapy.jpg';
import dyslexia_testing from '../../../assets/images/home_screen/slider/dyslexia_testing.jpg';
import reading_and_spelling from '../../../assets/images/home_screen/slider/reading_and_spelling.jpg';
import homework_help from '../../../assets/images/home_screen/slider/homework_help.jpg';
import teletherapy from '../../../assets/images/home_screen/slider/teletherapy.jpg';
import advocacy from '../../../assets/images/home_screen/slider/advocacy.jpg';

const data = [
  {
    text: 'PHYSICAL THERAPY',
    imgUrl: physical_therapy,
    link: '/services/physical-therapy',
  },
  {
    text: 'OCCUPATIONAL THERAPY',
    imgUrl: occupational_therapy,
    link: '/services/occupational-therapy',
  },
  {
    text: 'SPEECH THERAPY',
    imgUrl: speech_therapy,
    link: '/services/speech-therapy',
  },
  {
    text: 'DYSLEXIA TESTING AND INTERVENTION',
    imgUrl: dyslexia_testing,
    link: '/services/educational-service',
  },
  {
    text: 'READING AND SPELLING',
    imgUrl: reading_and_spelling,
    link: '/services/educational-service',
  },
  {
    text: 'HOMEWORK HELP',
    imgUrl: homework_help,
    link: '/services/educational-service',
  },
  { text: 'TELETHERAPY', imgUrl: teletherapy, link: '/services/telehealth' },
  { text: 'ADVOCACY', imgUrl: advocacy, link: '/services/educational-service' },
];

const LinksSlider = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const scrollSpeed = isMobile ? 20 : 35;

  const renderSlides = () =>
    data.map((item, index) => (
      <Link
        key={index}
        to={item.link}
        className="flex items-center justify-center h-[80px] sm:h-[100px] md:h-[115px] 
             min-w-[200px] sm:min-w-[230px] md:min-w-[265px] 
             w-[100px] sm:w-[230px] md:w-[265px] 
             rounded-xl md:rounded-2xl cursor-pointer"
        style={{
          backgroundImage: `url(${item.imgUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <motion.div
          whileHover={{ scale: 1.08 }}
          transition={{ type: 'spring', stiffness: 300, damping: 20 }}
          className="text-white font-bold text-center select-none 
                   text-[12px] sm:text-[16px] md:text-[20px] 2xl:text-[24px] 
                   leading-[93%] max-w-[150px] sm:max-w-[180px] md:max-w-[200px]"
        >
          {item.text}
        </motion.div>
      </Link>
    ));

  return (
    <div className="overflow-hidden w-full py-4 relative">
      <motion.div
        className="flex gap-4 w-max "
        animate={{ x: ['0%', '-50%'] }}
        transition={{
          repeat: Infinity,
          ease: 'linear',
          duration: scrollSpeed,
        }}
        style={{ display: 'flex' }}
      >
        {renderSlides()}
        {renderSlides()}
      </motion.div>
    </div>
  );
};

export default LinksSlider;
